import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes, SearchTypes } from '../constants/CentricConstants';
import Handlers from '../dispatcher/Handlers.js';
import AssetApi from '../server/AssetApi';
import AssetStore from '../stores/AssetStore';
import AssetTypeStore from '../stores/AssetTypeStore';

export const getAsset = (assetId) => {
    const types = {
        request:    ActionTypes.ASSET_INFO_REQUEST,
        success:    ActionTypes.ASSET_INFO_SUCCESS,
        failure:    ActionTypes.ASSET_INFO_FAILURE
    };

    return Dispatcher.dispatchAsync(AssetApi.getById(assetId), types, {assetId});
};

export const createAsset = () => Dispatcher.throttleDispatch({type: ActionTypes.ASSET_CREATE});
export const createAssetFromData = (defaults) => Dispatcher.throttleDispatch({type: ActionTypes.ASSET_CREATE, payload: (defaults || {})});

const editExistingAsset = async (id) => {
    const current = AssetStore.getById(id);
    const type = await getAssetType(current.typeId);
    return Dispatcher.dispatch({ type: ActionTypes.ASSET_EDIT, payload: { draft: {...current, type} }});
};

export const editAsset = (id, forceLoad = false) => {

    if (forceLoad || !AssetStore.getById(id)) {
        return getAsset(id).then(() => editExistingAsset(id));
    } else {
        return editExistingAsset(id);
    }
};
export const updateAssetDraft = (changes) => Dispatcher.dispatch({type: ActionTypes.ASSET_UPDATE, payload: {changes}});
export const discardAssetDraft = () => Dispatcher.dispatch({type: ActionTypes.ASSET_DISCARD });

export const getAssetType = (id) => {
    const type = AssetTypeStore.getById(id);
    if (type) {
        return type;
    } else {
        return getAssetTypes().then(() => AssetTypeStore.getById(id));
    }
};

export const getAssetTypeByName = (name) => {
    const type = AssetTypeStore.getByName(name);
    if (type) {
        return type
    } else {
        return getAssetTypes().then(() => AssetTypeStore.getByName(name));
    }
};

export const getAssetTypes = () => {
    const types = {
        request:    ActionTypes.ASSETTYPE_LIST_REQUEST,
        success:    ActionTypes.ASSETTYPE_LIST_SUCCESS,
        failure:    ActionTypes.ASSETTYPE_LIST_FAILURE
    };

    return Dispatcher.dispatchAsync(AssetApi.getAssetTypes(), types);
};

const insertAsset = (draft, discardOnSuccess = false) => {
    const types = {
        request:    ActionTypes.ASSET_ADD_REQUEST,
        success:    ActionTypes.ASSET_ADD_SUCCESS,
        failure:    ActionTypes.ASSET_ADD_FAILURE
    };
    const { asset, type, ...params } = draft;

    return Dispatcher.dispatchAsync(AssetApi.insert(params, (!!type.asAttachment && [asset])), types, {draft, discardOnSuccess});
};

const updateAsset = (draft, discardOnSuccess = false) => {
    const types = {
        request:    ActionTypes.ASSET_UPDATE_REQUEST,
        success:    ActionTypes.ASSET_UPDATE_SUCCESS,
        failure:    ActionTypes.ASSET_UPDATE_FAILURE
    };

    const { id, asset, type, ...params } = draft;
    const current = AssetStore.getById( id );

    return Dispatcher.dispatchAsync(AssetApi.update(id, params, (!!type.asAttachment && !!type.versionable && [asset])), types, {draft, current, discardOnSuccess});
};

export const saveAsset = (discardOnSuccess = false) => {
    const draft = AssetStore.getDraft();
    if (!draft) { return; } // guard
    if (!draft.id || !Number(draft.id)) {
        return insertAsset(draft, discardOnSuccess);
    } else {
        return updateAsset(draft, discardOnSuccess);
    }
};

export const saveAndDiscardAsset = () => saveAsset(true);

export const deleteAsset = (id) => {
    const current = AssetStore.getById(id);
    if (!current) { return Promise.reject(); }
    const types = {
        request:    ActionTypes.ASSET_DELETE_REQUEST,
        success:    ActionTypes.ASSET_DELETE_SUCCESS,
        failure:    ActionTypes.ASSET_DELETE_FAILURE
    };

    return Dispatcher.dispatchAsync(AssetApi.delete(id), types, {current});
};

export const uploadAsset = (draft) => {
    return insertAsset(draft).then(() => AssetStore.getLastId());
};

export default {

    getAll: (params, clearAll = false) => {
        const types = {
            request:    ActionTypes.ASSET_LIST_REQUEST,
            success:    ActionTypes.ASSET_LIST_SUCCESS,
            failure:    ActionTypes.ASSET_LIST_FAILURE
        };

        return Dispatcher.dispatchAsync(AssetApi.getAll(params), types, {...params, clearAll});
    },

    getById: getAsset,
    create: createAsset,
    edit: editAsset,
    save: saveAsset,
    saveAndDiscard: saveAndDiscardAsset,
    delete: deleteAsset,
    getTypes: getAssetTypes,

    search: (searchText, params, key = SearchTypes.ASSETS) => {
        const types = {
            request:    ActionTypes.SEARCH_REQUEST,
            success:    [ActionTypes.SEARCH_SUCCESS, ActionTypes.ASSET_LIST_SUCCESS],
            failure:    ActionTypes.SEARCH_FAILURE
        };

        return Dispatcher.dispatchAsync(AssetApi.search(searchText, params), types, {searchText, params, key});
    },

    searchContents: (searchText, options = {}) => {
        const types = {
            success: [ActionTypes.SEARCH_RESULT_RECEIVED, ActionTypes.ASSET_LIST_SUCCESS],
            failure: ActionTypes.SEARCH_ERROR
        };
        return Dispatcher.dispatchAsync(AssetApi.searchContents(searchText, options), types, {searchText, options});
    },

    getHistoryById: (assetId) => {
        const types = {
            request: ActionTypes.ASSET_HISTORY_REQUEST,
            success: ActionTypes.ASSET_HISTORY_SUCCESS,
            failure: ActionTypes.ASSET_HISTORY_FAILURE
        };
        return Dispatcher.dispatchAsync(AssetApi.getHistoryById(assetId), types, {assetId});
    }
};
